// extracted by mini-css-extract-plugin
var _1 = "TableLabelCell-moduleTableLabelCell__mKpRj TableCellText-moduleTableCellText__b5epO";
export { _1 as "TableLabelCell" }
